<div class="container">
  <label>LINK TO:</label>
  <input
    type="text"
    [ngModel]="link"
    (ngModelChange)="linkChange.emit($event)"
  />
</div>
